import { Box, Skeleton } from '@mui/material';

const TasksLoadingSkeleton = () => {
  return (
    <Box sx={{ width: '100%' }}>
      {/* Header skeleton */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
        }}
      >
        <Skeleton
          variant="rounded"
          width={180}
          height={40}
          sx={{ borderRadius: '8px' }}
        />
      </Box>

      {/* Table header skeleton */}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          mb: 2,
          px: 2,
        }}
      >
        <Skeleton variant="text" width="25%" height={20} />
        <Skeleton variant="text" width="20%" height={20} />
        <Skeleton variant="text" width="15%" height={20} />
        <Skeleton variant="text" width="20%" height={20} />
        <Skeleton variant="text" width="10%" height={20} />
      </Box>

      {/* Table rows skeleton */}
      {Array.from({ length: 5 }).map((_, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            gap: 2,
            alignItems: 'center',
            px: 2,
            py: 1.5,
            borderBottom: '1px solid #EAEDF1',
          }}
        >
          <Skeleton variant="text" width="25%" height={24} />
          <Skeleton
            variant="rounded"
            width="20%"
            height={24}
            sx={{ borderRadius: '50px' }}
          />
          <Skeleton
            variant="rounded"
            width="15%"
            height={24}
            sx={{ borderRadius: '50px' }}
          />
          <Skeleton variant="text" width="20%" height={24} />
          <Box sx={{ display: 'flex', gap: 1, width: '10%' }}>
            <Skeleton variant="circular" width={28} height={28} />
            <Skeleton variant="circular" width={28} height={28} />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default TasksLoadingSkeleton;
